import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../../shared/store/view/types';
import { ModuleId } from '../../../../shared/store/navigation/types';
import { CommissionPlanRuleCompanyCreateComponent } from './commission-plan-rule-company-create/commission-plan-rule-company-create.component';
import { CommissionPlanRuleCompanyEditComponent } from './commission-plan-rule-company-edit/commission-plan-rule-company-edit.component';
import { CommissionPlanRuleDetailsComponent } from '../commission-plan-rule-details/commission-plan-rule-details.component';

const routes: Routes = [
  {
    path: 'Finance/CommissionPlanRuleCompanies',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleCompany,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: CommissionPlanRuleDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleCompany,
          breadcrumb: { label: ' ', alias: 'commissionPlanRuleDetails' },
        },
      },
      {
        path: 'Create',
        component: CommissionPlanRuleCompanyCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleCompany,
          breadcrumb: { label: ' ', alias: 'commissionPlanRuleCompanyCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: CommissionPlanRuleCompanyEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleCompany,
          breadcrumb: { label: ' ', alias: 'commissionPlanRuleCompanyEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommissionPlanRuleCompanyRoutingModule {}
